import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AudienceProfilerKPI } from 'components/Segmentation/SegmentationBubble/AudienceProfilerChartHeader'
import { AudienceProfilerKPIOptions } from 'config/audienceProfilerKPI'

const initialState: AudienceProfilerKPI = AudienceProfilerKPIOptions[0]

const selectedAudienceProfilerKPI = createSlice({
  name: 'selectAudienceProfilerKPI',
  initialState,
  reducers: {
    selectAudienceProfilerKPI(state, action: PayloadAction<AudienceProfilerKPI>) {
      return action.payload
    },
  },
})

export const { selectAudienceProfilerKPI } = selectedAudienceProfilerKPI.actions

export default selectedAudienceProfilerKPI.reducer
